import { render, staticRenderFns } from "./agencyCredit.vue?vue&type=template&id=7080cd0d&scoped=true&"
import script from "./agencyCredit.vue?vue&type=script&lang=js&"
export * from "./agencyCredit.vue?vue&type=script&lang=js&"
import style0 from "./agencyCredit.vue?vue&type=style&index=0&id=7080cd0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080cd0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7080cd0d')) {
      api.createRecord('7080cd0d', component.options)
    } else {
      api.reload('7080cd0d', component.options)
    }
    module.hot.accept("./agencyCredit.vue?vue&type=template&id=7080cd0d&scoped=true&", function () {
      api.rerender('7080cd0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/agency/agencyCredit.vue"
export default component.exports